<div class="container-fluid mt-4">
    <div class="row align-items-center justify-content-center">
        <div class="col-10 text-white text-center">
            <h6 style="display: inline; clear: none; font-size: 12px;">NUESTROS </h6>
            <h6 class="brand-color" style="display: inline; clear: none; font-size: 12px;">PRINCIPALES SERVICIOS</h6>
            <h6 class="mt-2" style="font-size: 15px;">VARIEDAD DE SERVICIOS ENFOCADOS A CUMPLIR TODAS TUS NECESIDADES</h6>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12 text-center">
            <div class="row">
                <div class="col-4">
                    <app-shared-card-service
                        [img]="'../../../../../assets/services/seguridad-informatica.svg'"
                        [title]="'Seguridad Informática'"
                    ></app-shared-card-service>
                </div>
                <div class="col-4">
                    <app-shared-card-service
                        [img]="'../../../../../assets/services/paginas-web.svg'"
                        [title]="'Páginas y App Web'"
                    ></app-shared-card-service>
                </div>
                <div class="col-4">
                    <app-shared-card-service
                        [img]="'../../../../../assets/services/aplicaciones-moviles.svg'"
                        [title]="'Aplicaciones Móviles'"
                    ></app-shared-card-service>
                </div>
                <div class="col-4">
                    <app-shared-card-service
                      [img]="'../../../../../assets/services/ecommerce.svg'"
                      [title]="'Comercio Electrónico'"
                    ></app-shared-card-service>
                </div>
                <div class="col-4">
                    <app-shared-card-service
                      [img]="'../../../../../assets/services/arquitecturas-de-datos.svg'"
                      [title]="'Arquitectura de datos'"
                    ></app-shared-card-service>
                </div>
                <div class="col-4">
                    <app-shared-card-service
                      [img]="'../../../../../assets/services/inteligencia-artificial.svg'"
                      [title]="'Ciencia de Datos'"
                    ></app-shared-card-service>
                </div>
                <div class="col-4">
                    <app-shared-card-service
                      [img]="'../../../../../assets/services/microcontroladores-iot.svg'"
                      [title]="'Dispositivos IOT'"
                    ></app-shared-card-service>
                </div>
            </div>
            <button class="btn btn-lg btn-brand px-4" type="submit" style="font-size: 13px; font-weight: 500;" (click)="openSidebarLeft()">HAZ TU COTIZACIÓN</button>
        </div>
    </div>
</div>